module.exports = __webpack_public_path__ + "img/billingblock.b0575050.png";